import EmptyProject from '../../src/legacy/EmptyProject.tsx';
export default EmptyProject;
